<template>
  <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-12 items-center">
    <div class="bg-white w-fullrounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex">
          <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>
          <div class="text-xl font-semibold text-green-500 ">
            {{ $t("import_orders") }}
          </div>
        </div>
      </div>

      <div
        class="mx-6 md:flex mb-6 border p-5 border-dotted rounded-md border-gray-500"
      >
        <div v-if="sellers.length > 0" class="md:w-1/2 px-3 mb-6 md:mb-0">
          <div
            class="border-2 h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
          >
            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
              <p>
                <label for="seller" class="bg-white text-gray-700 px-1"
                  >{{ $t("select_seller") }}
                  <span :class="$colors.required">*</span></label
                >
              </p>
            </div>
            <p>
              <v-select
                label="fullName"
                :options="sellers"
                @input="setSelected"
              >
              </v-select>
            </p>
          </div>
        </div>
        <div class="md:w-1/2 px-3">
          <div
            class="border-2 h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1"
          >
            <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
              <p>
                <label for="seller" class="bg-white text-gray-700 px-1"
                  >Country ({{ $t("warehouse") }})
                  <span :class="$colors.required">*</span></label
                >
              </p>
            </div>
            <p>
              <v-select
                @input="setSelectedW"
                :options="warehousesUser"
                label="countryName"
              >
                <template slot="option" slot-scope="option">
                  <img
                    class="flag-img"
                    :src="$f.getCountryCode(option.country)"
                  />
                  {{ option.countryName }}
                </template>
              </v-select>
            </p>
          </div>
        </div>
      </div>

      <div class="px-6 mt-3">
        <div class="relative">
          <loading :active.sync="loading" :is-full-page="fullPage"></loading>
          <div class="border border-dashed border-gray-500">
            <input
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              @change="processFile($event)"
              ref="csvOrdersFile"
              type="file"
              class="cursor-pointer relative block opacity-0 w-full h-full p-20 z-50"
            />
            <div class="text-center p-10 absolute top-0 right-0 left-0 m-auto">
              <h4>{{ $t("drag_file") }}</h4>
              <p v-if="this.selectedFileName" class="font-bold">
                {{ $t("selected_file") }}
                <span class="text-green-500 ">{{ this.selectedFileName }}</span>
              </p>
            </div>
          </div>
          <div class="p-5 grid justify-items-center">
            <button
              @click="uploadOrders"
              icon="publish"
              :disabled="loading"
              class="flex items-stretch rounded-md mx-1 border border-gray-100 bg-green-600  hover:bg-green-600  text-white py-2 px-4 focus:outline-none loidingconfirm relative"
              :class="loading ? 'noselect' : ''"
            >
              <loading
                :active.sync="loading"
                :is-full-page="fullPage"
              ></loading>
              <i class="self-center material-icons">publish</i>
              {{ $t("upload") }}
            </button>
          </div>
        </div>
        <div v-if="messages.length > 0">
          <table class="min-w-full leading-normal table-messages">
            <thead>
              <tr>
                <th
                  class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                >
                  {{ $t("orderid") }}
                </th>

                <th
                  class="px-8 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-600 uppercase tracking-wider"
                >
                  {{ $t("message") }}
                </th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in messages" :key="index">
              <tr>
                <td
                  class="px-6 py-2 whitespace-no-wrap border-b border-gray-200"
                >
                  <div
                    class="text-xs leading-5 capitalize px-2 font-semibold rounded-full text-gray-900"
                  >
                    {{ item.orderId }}
                  </div>
                </td>

                <td
                  class="px-6 py-2 whitespace-no-wrap border-b border-gray-200"
                >
                  <div
                    :class="item.type"
                    class="text-xs leading-5 capitalize px-2 font-semibold rounded-full text-gray-900"
                  >
                    {{ item.text }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--p>The csv file should be structered like example below:</p-->
        <button
          @click="downloadcsvExample"
          icon="publish"
          class="flex items-stretch rounded-md mx-1 border border-gray-100 bg-green-600  hover:bg-green-600  text-white py-2 px-4 focus:outline-none"
        >
          <i class="self-center material-icons">file_download</i>
          {{ $t("download_xlsx_example") }}
        </button>

        <!-- <button
            @click="downloadxlsxExample"
            icon="publish"
            class="flex items-stretch rounded-md mx-1 border border-gray-100 bg-green-600  hover:bg-green-600  text-white py-2 px-4 focus:outline-none"
          >
            <i class="self-center material-icons">file_download</i> {{$t('download_xlsx_example')}}
          </button> -->

        <!--img src="../../assets/csvFileExample.png" /-->
      </div>

      <br />
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
  },
  data() {
    return {
      formData: { warehouse: null, idWharhouse: null },
      messages: [],

      sellers: [],
      warehouses: [],
      warehousesUser: [],
      loading: false,
      fullPage: false,
      selectedFileName: "",
      selectContry: "",
    };
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters["wharhouse/warhouseSelected"]({
        user: _.pick(this.currentUser, ["countries"]),
      });
    },
  },
  watch: {
    warhouseSelected: async function(oldVal, newVal) {},
    idWharhouse: async function(oldVal, newVal) {
      this.idWharhouse = oldVal;
      await this.getCurrentSeller();
    },
  },
  async mounted() {
    await this.getCurrentSeller();
  },
  methods: {
    RouterBack: function() {
      this.$router.back();
    },
    async getWarehouses() {
      const filter = { limit: 10 };
      const res = await this.$server.search("warehouses", filter);
      if (res && res.content.results) {
        this.warehouses = res.content.results;
      } else this.warehouses = [];
    },
    async setSelectedW(contry) {
      if (contry) {
        this.formData.warehouse = contry.country;
        this.formData.idWharhouse = contry._id;
      } else {
        this.formData.warehouse = null;
        this.formData.idWharhouse = null;
      }
    },
    async getwharhouseId() {
      await this.$store
        .dispatch("wharhouse/getwharhouseId", {
          country: await this.warhouseSelected,
        })
        .then((res) => {
          this.idWharhouse = res;
          this.formData.idWharhouse = res;
        });
    },
    setSelected(seller) {
      if (seller) {
        this.formData.seller = seller;
      } else {
        this.formData.seller = "";
      }
    },
    async save() {},
    async processFile(event) {
      if (event.target.files.length) {
        var reader = new FileReader();
        let ExtensionFile = event.target.files[0].name.split(".").pop();
        console.log("event.target.files[0]", event.target.files[0].type);
        if (ExtensionFile == "csv") {
          this.selectedFileName = event.target.files[0].name;

          reader.onload = async (e) => {
            this.formData.file = e.target.result.split(",")[1];
            this.formData.type = "Csv";
          };
          reader.readAsDataURL(event.target.files[0]);
        } else {
          reader.onload = (e) => {
            /* Parse data */
            const bstr = e.target.result;
            this.selectedFileName = event.target.files[0].name;
            const wb = XLSX.read(bstr, { type: "binary", cellDates: true });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
            this.formData.file = data.filter(function(x) {
              return x.length;
            });
            this.formData.type = "Excel";
          };

          reader.readAsBinaryString(event.target.files[0]);
        }
      } else {
        this.formData.file = "";
        this.selectedFileName = "";
      }
      this.messages = [];
    },
    getElementInArray(data, value) {
      var result = data.filter(function(o) {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar == value.toString();
      });
      return result ? result[0] : null;
    },

    async getStatusByName(name) {
      const result = await this.$server.get("status", { name: name });
      return result.content._id;
    },

    async uploadOrders() {
      this.loading = true;
      if (
        this.formData.file &&
        this.formData.seller &&
        this.formData.warehouse
      ) {
        let dataWhrahouseSetting = null;
        if (this.formData.seller.settings.length > 0) {
          dataWhrahouseSetting = this.getElementInArray(
            this.formData.seller.settings,
            this.formData.idWharhouse
          );
        }

        if (
          !dataWhrahouseSetting ||
          (dataWhrahouseSetting &&
            !dataWhrahouseSetting.confirmation &&
            !dataWhrahouseSetting.fulfillement &&
            !dataWhrahouseSetting.shipping)
        ) {
          alert(
            "vous n'avait pas activé aucun services veuillez contacter administration rmExpress",
            "warning"
          );
          this.loading = false;
          return false;
        }

        const outOfStockStatus = await this.getStatusByName("OutOfStock");
        const pending = await this.getStatusByName("Pending");

        let messagesorders = [];
        const nDate = new Date().toLocaleString("en-US", {
          timeZone: "Africa/Casablanca",
        });

        if (this.formData.seller.status != "active") {
          alert(
            "Cette user n'est pas active contacter rmExpress pour l'activer merci",
            "warning"
          );
          this.loading = false;
          return false;
        }

        let order = {
          seller: this.formData.seller,
          warehouse: this.formData.warehouse._id || this.formData.warehouse,
        };
        let orderslines = [];

        if (this.formData.file.length == 0) {
          alert("Empty file!", "error");
          this.loading = false;
          return false;
        }
        if (this.formData.file.length < 2) {
          alert("File contains only the header!", "error");
          this.loading = false;
          return false;
        }

        this.loading = true;
        this.itemsOrders = 0;
        this.showprogress = true;

        // Check file organization
        orderslines = this.formData.file;
        orderslines.forEach(function(element, i) {
          const elementrow = element.filter(function(el) {
            return el;
          });
          if (elementrow.length > 10) {
            let message = {
              orderId: element[0],
              text: `Order not properly organized in line ${i +
                1}, probably the customer information consists of (,) replace it with (;) and try again`,
              type: "error",
              sort: i + 1,
            };
            messagesorders.push(message);
            orderslines = orderslines.filter(
              function(obj) {
                return obj[0].toString() !== element[0].toString();
              }.bind(this)
            );
          } else {
            element.push(i + 1);
          }
        });

        // Enhanced grouping logic
        var ress = orderslines
          .reduce(function(ress, currentValue) {
            let productIdentifier = currentValue[2]
              ? currentValue[2].toString().trim()
              : "";

            if (
              currentValue[8] &&
              currentValue[8].toString().toLowerCase() != "quantity" &&
              productIdentifier
            ) {
              if (ress.findIndex((i) => i.name === productIdentifier) === -1) {
                ress.push({
                  name: productIdentifier,
                  isVariant: productIdentifier.startsWith("VA"), // Check if it's a variant ID
                });
              }
            }
            return ress;
          }, [])
          .map(function(group) {
            return {
              product: group,
              datas: orderslines
                .filter(function(_el) {
                  return _el[2] && _el[2].toString().trim() === group.name;
                })
                .map(function(_el) {
                  return {
                    id: _el[0].toString().trim(),
                    order_id: _el[0].toString().trim(),
                    date: new Date(nDate),
                    product_name: _el[2] ? _el[2].toString().trim() : "",
                    "customer.fullName": _el[3]
                      ? _el[3].toString().trim()
                      : null,
                    "customer.phone": _el[4]
                      ? _el[4].toString().replace(/[^|\d]/g, "")
                      : null,
                    "customer.country": order.warehouse,
                    "customer.address": _el[5] ? _el[5].toString() : null,
                    "customer.shippingAddress": _el[5]
                      ? _el[5].toString()
                      : null,
                    "customer.city": _el[6] ? _el[6].toString() : null,
                    price: _el[7],
                    quantity: _el[8] ? _el[8] : null,
                    source: _el[9] ? _el[9] : null,
                    seller: order.seller,
                    totalPrice: _el[7],
                    details: [],
                    line: _el[10] || _el[9],
                  };
                }),
            };
          });

        console.log("orderslines", orderslines);
        console.log("ress", ress);

        // Process each product group
        for (let i = 0; i < ress.length; i++) {
          let resP = null;
          let foundVariant = null;
          let actualProductId = null;

          // First try to find by product ID/name
          resP = await this.$server.get("products", {
            ProductBynameAndId: true,
            warehouse:
              this.formData.idWharhouse._id || this.formData.idWharhouse,
            id: ress[i].product.name,
            name: ress[i].product.name,
            seller: this.formData.seller._id || this.formData.seller,
          });

          // If not found and it looks like a variant ID, search for the product containing this variant
          if (
            (!resP.content || !resP.content._id) &&
            ress[i].product.isVariant
          ) {
            console.log("Searching for variant ID:", ress[i].product.name);

            // Search all products for this seller to find the one containing this variant
            const searchResult = await this.$server.search("products", {
              seller: this.formData.seller._id || this.formData.seller,
              isDeleted: null,
              limit: 1000, // Increase limit to ensure we find the product
            });

            if (
              searchResult &&
              searchResult.content &&
              searchResult.content.results
            ) {
              // Look through all products to find the one with this variant
              for (let product of searchResult.content.results) {
                if (product.details && product.details.length > 0) {
                  for (let detail of product.details) {
                    if (detail.variantes && detail.variantes.length > 0) {
                      const variant = detail.variantes.find(
                        (v) =>
                          v.id === ress[i].product.name ||
                          v.code === ress[i].product.name
                      );
                      if (variant) {
                        // Found the product containing this variant
                        resP = await this.$server.get("products", {
                          _id: product._id,
                        });
                        foundVariant = variant;
                        actualProductId = product.id || product.id_v2;
                        break;
                      }
                    }
                  }
                  if (foundVariant) break;
                }
              }
            }
          }

          if (!resP.content || (resP.content && !resP.content._id)) {
            ress[i].datas.forEach(function(element) {
              let message = {
                orderId: element.order_id,
                text: `Product id: ${element.product_name} in line ${element.line} not exist`,
                type: "error",
                sort: element.line,
              };
              messagesorders.push(message);
            });
          } else {
            ress[i].inStock = 0;
            ress[i].productID = resP.content._id;
            ress[i].detailsPR = resP.content.details;
            ress[i].type = resP.content.type;
            ress[i].outOfStock = true;

            // Get warehouse-specific product details
            const dataWhrahousePr = this.getElementInArrayByCountry(
              resP.content.details,
              this.formData.idWharhouse._id || this.formData.idWharhouse
            );

            if (dataWhrahousePr && !dataWhrahousePr.outOfStock) {
              ress[i].inStock = dataWhrahousePr.quantity.inStock;
              ress[i].outOfStock = dataWhrahousePr.outOfStock;
            }

            // Handle variant stock
            if (foundVariant || ress[i].product.isVariant) {
              let variantId = foundVariant
                ? foundVariant.id
                : ress[i].product.name;
              let variantStock = 0;
              let variantOutOfStock = true;
              let variantInfo = null;

              // Find the variant in the warehouse details
              for (let detail of resP.content.details) {
                if (
                  detail.warehouse._id &&
                  (detail.warehouse._id.toString() ===
                    (
                      this.formData.idWharhouse._id || this.formData.idWharhouse
                    ).toString() ||
                    (detail.warehouse.parent &&
                      detail.warehouse.parent._id &&
                      detail.warehouse.parent._id.toString() ===
                        (
                          this.formData.idWharhouse._id ||
                          this.formData.idWharhouse
                        ).toString()))
                ) {
                  if (detail.variantes && detail.variantes.length > 0) {
                    const variant = detail.variantes.find(
                      (v) => v.id === variantId || v.code === variantId
                    );

                    if (variant) {
                      variantStock = variant.quantity
                        ? variant.quantity.inStock
                        : 0;
                      variantOutOfStock = variant.outOfStock || false;
                      variantInfo = variant;
                      break;
                    }
                  }
                }
              }

              if (variantInfo) {
                ress[i].inStock = variantStock;
                ress[i].outOfStock = variantOutOfStock;
                ress[i].variantInfo = variantInfo;

                // Update product data with variant info
                ress[i].datas.forEach(function(data) {
                  data.variant_id = variantInfo.id;
                  data.variant_name = variantInfo.name;
                  // If we found the product by variant ID, update the product name
                  if (actualProductId) {
                    data.product_name = actualProductId;
                  }
                });
              } else {
                // Variant not found in warehouse
                ress[i].datas.forEach(function(element) {
                  let message = {
                    orderId: element.order_id,
                    text: `Variant ${variantId} not found in warehouse in line ${element.line}`,
                    type: "error",
                    sort: element.line,
                  };
                  messagesorders.push(message);
                });
                ress[i].datas = []; // Clear data to prevent order creation
                continue;
              }
            }

            console.log("ress[i]", ress[i].datas);

            // Remove duplicate orders
            const duplicateDataOrder = ress[i].datas
              .map((e) => e["order_id"].toString())
              .map((e, i, final) => final.indexOf(e) !== i && i)
              .filter((obj) => ress[i].datas[obj])
              .map((e) => ress[i].datas[e]);

            ress[i].datas = _.uniqBy(ress[i].datas, "order_id");

            duplicateDataOrder.forEach(
              function(orderD) {
                let message = {
                  orderId: orderD.order_id,
                  text: `Order id ${orderD.order_id} in line ${orderD.line} duplicated`,
                  type: "warn",
                  sort: orderD.line,
                };
                messagesorders.push(message);
              }.bind(this)
            );

            // Check for duplicate orders by product & phone
            let duplicates = [];
            let tempArray = [];

            ress[i].datas.forEach((element, key) => {
              let isAlreadyAdded = tempArray.find(
                (item) =>
                  item.product_name &&
                  element.product_name &&
                  item.product_name === element.product_name &&
                  item["customer.phone"] &&
                  element["customer.phone"] &&
                  item["customer.phone"] === element["customer.phone"] &&
                  item.variant_id === element.variant_id
              );
              if (!isAlreadyAdded) tempArray.push(element);
              else duplicates.push(element);
            });

            duplicates.forEach(
              function(orderD) {
                let message = {
                  orderId: orderD.order_id,
                  text: `Order in line ${orderD.line}, contient produit et telephone existe deja dans un autre commande`,
                  type: "warn",
                  sort: orderD.line,
                };
                messagesorders.push(message);
                ress[i].datas = ress[i].datas.filter(
                  function(obj) {
                    return obj.order_id.toString() !== orderD.order_id;
                  }.bind(this)
                );
              }.bind(this)
            );

            // Check existing orders
            var x = ress[i].datas.map((el) => el.order_id);
            let dataOrders = [];
            var itemsCounts = 100;
            var count = Math.ceil(x.length / itemsCounts);
            var close = false;

            for (var d = 0; d < count; d++) {
              if (close) return;
              var s = x.slice(d * itemsCounts, d * itemsCounts + itemsCounts);
              const checkedOrders = await this.$server.bigSearch("orders", {
                byIds: s,
                "customer.country": this.formData.warehouse,
                limit: 10,
              });

              if (checkedOrders && checkedOrders.content) {
                if (
                  checkedOrders.content.results &&
                  checkedOrders.content.results.length > 0
                ) {
                  for (let p in checkedOrders.content.results) {
                    dataOrders.push(checkedOrders.content.results[p].id);
                  }
                }
              } else close = true;

              if (close) {
                alert(
                  "Une erreur s'est produite, Le nombre des commandes est peut-être trop élevé. Veuillez résoudre le problème et réessayer.",
                  "warning"
                );
              }
            }

            if (dataOrders && dataOrders.length > 0) {
              dataOrders.forEach(
                function(element) {
                  let filterObj = ress[i].datas.filter(
                    function(e) {
                      return e.order_id.toString() == element;
                    }.bind(this)
                  );

                  if (filterObj.length > 0) {
                    let message = {
                      orderId: element,
                      text: `Order ID in line ${filterObj[0].line} already exist in the system`,
                      type: "warn",
                      sort: filterObj[0].line,
                    };
                    messagesorders.push(message);
                  }
                  ress[i].datas = ress[i].datas.filter(
                    function(obj) {
                      return obj.order_id.toString() !== element;
                    }.bind(this)
                  );
                }.bind(this)
              );
            }

            // Validate orders
            ress[i].datas.forEach(
              function(element) {
                if (
                  !element["customer.phone"] ||
                  !element["customer.fullName"] ||
                  !element["customer.address"] ||
                  !element.quantity ||
                  !element.source
                ) {
                  let field = "Phone number";
                  if (!element["customer.fullName"])
                    field = "Customer fullName";
                  if (!element["customer.address"]) field = "Address";
                  if (!element.quantity) field = "Quantity";
                  if (!element.source) field = "Store";

                  let message = {
                    orderId: element.order_id,
                    text: `${field} is required in line ${element.line}`,
                    type: "error",
                    sort: element.line,
                  };
                  messagesorders.push(message);
                  ress[i].datas = ress[i].datas.filter(
                    function(obj) {
                      return obj.order_id.toString() !== element.order_id;
                    }.bind(this)
                  );
                }

                if (
                  element.quantity &&
                  !isNaN(element.quantity) &&
                  parseInt(element.quantity) > 10
                ) {
                  let message = {
                    orderId: element.order_id,
                    text: `Check the quantity you entered is too large in line ${element.line}`,
                    type: "error",
                    sort: element.line,
                  };
                  messagesorders.push(message);
                  ress[i].datas = ress[i].datas.filter(
                    function(obj) {
                      return obj.order_id.toString() !== element.order_id;
                    }.bind(this)
                  );
                }

                if (element.quantity && isNaN(element.quantity)) {
                  let message = {
                    orderId: element.order_id,
                    text: `Check the quantity you entered, it must be a number in line ${element.line}`,
                    type: "error",
                    sort: element.line,
                  };
                  messagesorders.push(message);
                  ress[i].datas = ress[i].datas.filter(
                    function(obj) {
                      return obj.order_id.toString() !== element.order_id;
                    }.bind(this)
                  );
                }

                if (element.price && isNaN(element.price)) {
                  let message = {
                    orderId: element.order_id,
                    text: `Check the price you entered, it must be a number in line ${element.line}`,
                    type: "error",
                    sort: element.line,
                  };
                  messagesorders.push(message);
                  ress[i].datas = ress[i].datas.filter(
                    function(obj) {
                      return obj.order_id.toString() !== element.order_id;
                    }.bind(this)
                  );
                }

                // Prepare product line
                let productLine = {};
                productLine.product = ress[i].productID;
                element.type = ress[i].type;
                productLine.unitPrice = 0;
                productLine.details = ress[i].detailsPR;

                // Add variant info if present
                if (ress[i].variantInfo) {
                  productLine.variante = {
                    id: ress[i].variantInfo.id,
                    name: ress[i].variantInfo.name,
                    picture: ress[i].variantInfo.picture,
                  };
                }

                if (element.totalPrice && element.quantity) {
                  productLine.unitPrice = element.totalPrice / element.quantity;
                }
                productLine.quantity = element.quantity;

                element.details.push(productLine);
                element.status = pending;
                element.statusCallcenter = pending;

                // Check stock status
                if (
                  ress[i].outOfStock ||
                  parseInt(ress[i].inStock) < parseInt(element.quantity)
                ) {
                  element.status = outOfStockStatus;
                  element.statusCallcenter = outOfStockStatus;
                }
              }.bind(this)
            );

            console.log("res data---------", ress[i].datas);

            // Insert valid orders
            if (ress[i].datas.length > 0) {
              var itemsCounts = 100;
              var count = Math.ceil(ress[i].datas.length / itemsCounts);
              var close = false;

              for (var o = 0; o < count; o++) {
                if (close) return;
                var s = ress[i].datas.slice(
                  o * itemsCounts,
                  o * itemsCounts + itemsCounts
                );
                const insertdatas = await this.$server.insertMany("orders", s);
                console.log(i, Date.now());

                if (insertdatas) {
                  if (Array.isArray(insertdatas)) {
                    this.itemsOrders += s.length;
                    s.forEach(
                      function(element) {
                        let variantText = ress[i].variantInfo
                          ? ` (Variant: ${ress[i].variantInfo.name})`
                          : "";
                        let message = {
                          orderId: element.order_id,
                          text: `Order created${variantText}`,
                          type: "success",
                          sort: element.line,
                        };
                        messagesorders.push(message);
                      }.bind(this)
                    );
                  } else {
                    let message = {
                      orderId: "The problem",
                      text: `Among these orders id, there is a problem {${s.map(
                        (el) => el.order_id
                      )}} error: ${insertdatas}`,
                      type: "error",
                    };
                    messagesorders.push(message);
                    close = true;
                  }
                }

                if (close) {
                  this.loading = false;
                  this.showprogress = false;
                  this.itemsOrders = 0;
                }
              }
            }
          }
        }

        // Sort messages by line number
        messagesorders.sort(function(a, b) {
          return a.sort - b.sort;
        });

        this.loading = false;
        this.showprogress = false;

        if (messagesorders.length > 0) {
          this.$vm2.open("messages");
          this.messages = messagesorders;
          alert("Upload result is ready!", "default");
          this.formData.file = "";
          this.selectedFileName = "";
        } else {
          alert(
            "Une Erreur S'est Produite, Veuillez Réessayer Plus Tard",
            "error"
          );
        }
      } else {
        const isFilePresent = !!this.formData.file;
        const isSellerPresent = !!this.formData.seller;
        const isWarhousePresent = !!this.formData.warehouse;
        this.loading = false;

        let msg = "";
        if (!isFilePresent || !isSellerPresent || !isWarhousePresent) {
          msg = "please specify ";
          if (!isFilePresent) msg = msg + "the file";
          if (!isFilePresent && !isSellerPresent) msg = msg + " and ";
          if (!isSellerPresent) msg = msg + "the seller";
          if (!isFilePresent && !isWarhousePresent) msg = msg + " and ";
          if (!isWarhousePresent) msg = msg + "the country";
        }

        if (!!msg) {
          alert(msg);
        }
      }

      this.$refs.csvOrdersFile.value = null;
    },

    getElementInArrayByCountry(data, value) {
      console.log("details pr----------", data);
      console.log("warehouseID----------", value);

      var result = data.filter(function(o) {
        // Check both warehouse ID and parent warehouse ID
        return (
          (o.warehouse &&
            o.warehouse._id &&
            o.warehouse._id.toString() === value.toString()) ||
          (o.warehouse &&
            o.warehouse.parent &&
            o.warehouse.parent._id &&
            o.warehouse.parent._id.toString() === value.toString())
        );
      });

      if (result && result.length > 0) {
        console.log(
          "qte=====>",
          result.reduce((n, { quantity }) => n + quantity.inStock, 0)
        );

        // Find the main warehouse entry (not parent)
        const mainWarehouse = result.find(
          (z) =>
            z.warehouse &&
            z.warehouse._id &&
            z.warehouse._id.toString() == value.toString()
        );

        if (mainWarehouse) {
          return {
            outOfStock: mainWarehouse.outOfStock,
            quantity: {
              total: result.reduce((n, { quantity }) => n + quantity.total, 0),
              inStock: result.reduce(
                (n, { quantity }) => n + quantity.inStock,
                0
              ),
              defective: result.reduce(
                (n, { quantity }) => n + quantity.defective,
                0
              ),
            },
          };
        }
      }

      return null;
    },
    async getCurrentSeller() {
      if (this.currentUser && this.currentUser.type) {
        if (this.currentUser.type != "Seller") await this.getSellers();
        else this.formData.seller = this.currentUser;

        await this.getWarehouses();

        for (let i in this.warehouses) {
          for (let j in this.currentUser.countries) {
            if (
              !this.warehousesUser.find(
                (o) => o.country === this.warehouses[i].country
              ) &&
              (this.warehouses[i].country ===
                this.currentUser.countries[j].code ||
                this.currentUser.countries[j])
            ) {
              this.warehousesUser.push(this.warehouses[i]);
            }
          }
        }
        console.log("warehousesUser------", this.warehousesUser);
      }
    },
    async getSellers() {
      const res = await this.$server.search("users", {
        type: "Seller",
        countries: this.idWharhouse.country,
        limit: 10,
      });
      if (res && res.content.results) {
        this.sellers = res.content.results;
        this.sellers.push({
          _id: "66f164810c31de016fef5613",
          verify: {
            code: 11223344,
            createdAt: {
              $date: "2024-09-17T12:09:35.418Z",
            },
            sms: false,
            emailManager: false,
          },
          identity: {
            isIdentity: false,
            status: "invalid",
            selfie: null,
            identity: null,
          },
          isUpdate: false,
          status: "active",
          type: "Seller",
          isAtlasSourcing: false,
          zones: [],
          countries: ["CG", "CD"],
          disabledCountries: [],
          source: null,
          createdAt: {
            $date: "2024-09-23T12:52:17.000Z",
          },
          updatedAt: {
            $date: "2024-09-23T13:59:34.000Z",
          },
          isDeleted: null,
          role: "6027068186075ed703191698",
          email: "seller.abdelali@gmail.com",
          fullName: "Abdelali Seller",
          phone: "+212600998877",
          settings: [
            {
              open_colis: false,
              confirmation: true,
              fulfillement: true,
              shipping: true,
              _id: "66f164810c31de016fef5614",
              warehouse: "66a12253e7c8bb002f8112d5",
            },
            {
              open_colis: false,
              confirmation: true,
              fulfillement: true,
              shipping: true,
              _id: "670ce9dda37f7e00804401d3",
              warehouse: "66b35b2da2157f00b2d2a11c",
            },
          ],
          password:
            "$2a$10$H4Z9M3jvqYn2Dc.xbb5Kg.VC6gsb37F9PcyHvQb9GyF8SuZAn5ZY6",
          api: {
            key: "26uqyjhixp1qeej9divstl6fpgehp77wdmbrnqiv",
            secret: "df2j81sqomxzphzuetytp3mhaazke8tkk3ffgurt",
          },
          teams: [],
          sous_warehouses: [],
          fees: [
            {
              confirmation: -1,
              fulfillement_fees: -1,
              shipping: -1,
              refund: -1,
              change: -1,
              cancelation: -1,
              quality_control: -1,
              _id: "670c1d85a37f7e008043fb53",
              warehouse: "66a12253e7c8bb002f8112d5",
            },
          ],
          notifications: [],
          prefixs: [],
          accountManagers: [],
          __v: 0,
          rib: "4152430211009100",
          username: "abdelali_seller",
          classements: {},
        });
      } else this.sellers = [];
    },
    async downloadcsvExample() {
      let link = window.document.createElement("a");

      link.href =
        "https://storeno.b-cdn.net/saas/files-2-2022/1643717907400.xls";
      link.download = "orders_exemple.xls";
      link.click();
    },
    async downloadxlsxExample() {
      var blob = new Blob(
        [
          "ORDER ID,DATE,PRODUCT NAME,CONSTUMER NAME,PHONE NUMBER,ADRESSE,CITY,PRICE,QUANTITY,STORE",
        ],
        {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        }
      );
      var url = window.URL || window.webkitURL;
      let link = url.createObjectURL(blob);
      var a = document.createElement("a");
      a.setAttribute("download", "orders_example.xlsx");
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>

<style scoped>
.table-messages {
  display: block;
  max-height: 500px;
  overflow: auto;
  margin-bottom: 35px;
}

.error {
  color: #c62525;
}

.success {
  color: #25c631;
}

.warn {
  color: #ff9800;
}
</style>
